import { InputNumber, Pagination, Select } from "zhihao-ui-react";
import { useEffect, useState } from "react";

export interface TablePaginationProps {
    current: number;
    pageSize: number;
    total: number;
    className?: string;
    onChange: (page: number, pageSize: number) => void;
}

/** 对应旧 Vue ProTable pagination.vue，统一总数、页容量、页码和跳转区。 */
export function TablePagination({ current, pageSize, total, className, onChange }: TablePaginationProps) {
    const [jumpPage, setJumpPage] = useState<number | string>(current);
    const maxPage = Math.max(1, Math.ceil(total / pageSize));

    useEffect(() => setJumpPage(current), [current]);

    /** 对跳转页码统一做边界收敛，避免各业务页重复实现。 */
    const changePage = (nextPage: number, nextSize = pageSize) => {
        const nextMaxPage = Math.max(1, Math.ceil(total / nextSize));
        const safePage = Math.min(Math.max(Number(nextPage) || 1, 1), nextMaxPage);
        setJumpPage(safePage);
        onChange(safePage, nextSize);
    };

    if (!total) return null;
    return <div className={`pro-table__pagination${className ? ` ${className}` : ""}`}>
        <span className="pro-table__pagination-total">共{total}条数据</span>
        <Select aria-label="每页条数" value={pageSize} options={[10, 20, 50, 100].map(value => ({ label: `${value}条/页`, value }))} onChange={value => changePage(1, value)} />
        <Pagination current={current} pageSize={pageSize} total={total} showSizeChanger={false} onChange={page => changePage(page)} />
        <label className="pro-table__pagination-jumper">
            跳至
            <InputNumber aria-label="跳转页码" min={1} max={maxPage} value={jumpPage} onChange={setJumpPage} onPressEnter={() => changePage(Number(jumpPage) || 1)} onBlur={() => changePage(Number(jumpPage) || 1)} />
            页
        </label>
    </div>;
}
